require('./overrides.scss')

export default {
  theme: {
    themes: {
      light: {
        primary: '#002855',
        accent: '#FFA800',
        secondary: '#6B7280',
        success: '#22C55E',
        info: '#00366e',
        warning: '#FFA800',
        error: '#EF4444',
        mobilePrimary: '#002855',
        mobileSecondary: '#00172f',
      },
      dark: {
        primary: '#FFA800',
        accent: '#002855',
        secondary: '#9CA3AF',
        success: '#22C55E',
        info: '#7EB6FF',
        warning: '#FFA800',
        error: '#EF4444',
        mobilePrimary: '#002855',
        mobileSecondary: '#00172f',
      },
    //   dark: {
    //     primary: '#9155FD',
    //     accent: '#0d6efd',
    //     secondary: '#8A8D93',
    //     success: '#56CA00',
    //     info: '#16B1FF',
    //     warning: '#FFB400',
    //     error: '#FF4C51',
    //   },
    },
  },
}
